import courseFallbackImage from "../assets/course-fallback.jpg";
import { ENV } from "config/environment";

/**
 * Robustly extracts the image URL from a course object.
 * Checks multiple fields to handle legacy data and different backend responses.
 * 
 * Priority:
 * 1. coverImage.url (Standard)
 * 2. coverImage (If string)
 * 3. thumbnailUrl (Legacy/Bunny)
 * 4. image (Legacy)
 * 5. thumbnailKey (Local Uploads)
 * 6. Fallback Image
 */
export const getCourseImageUrl = (course) => {
  if (!course) return courseFallbackImage;

  // 1. Check coverImage (Standard)
  if (course.coverImage) {
    if (typeof course.coverImage === 'string') return course.coverImage;
    if (course.coverImage.url) return course.coverImage.url;
  }

  // 2. Check thumbnailUrl (Often mapped from coverImage or Bunny)
  if (course.thumbnailUrl) return course.thumbnailUrl;

  // 3. Check image (Legacy string)
  if (course.image) return course.image;

  // 4. Check thumbnailKey (Local file system fallback)
  if (course.thumbnailKey) {
    const baseUrl = ENV.API_BASE_URL.replace(/\/api\/?$/, "");
    return `${baseUrl}/uploads/${course.thumbnailKey}`;
  }

  // 5. Fallback
  return courseFallbackImage;
};
